import Typography from "@mui/material/Typography";
import { type ReactElement } from "react";
import { TilesSection } from "../../components/WhatsNew/TilesSection";
import { blogPosts } from "./utils";

export default function BlogPage(): ReactElement {
  return (
    <TilesSection
      hasHero
      cards={blogPosts}
      empty={
        <Typography
          component={"h4"}
          variant="h4"
          sx={{
            cursor: "pointer",
          }}
        >
          Check back soon for exciting content!
        </Typography>
      }
      enableFakeLoading
    />
  );
}
